import { FC, MouseEvent } from 'react';
import { Play, RotateCcw, X } from 'lucide-react';
import type { UserCourse } from '@teachur/http-client';

const COURSE_ACTION_BUTTON_CLASS =
  'cursor-pointer p-1 rounded-full! transition-colors text-(--neutral-black-NB600)!';

const COURSE_ACTION_ICON_CLASS = 'w-4 h-4';

interface CourseActionButtonsProps {
  userCourse: UserCourse;
  isAdmin: boolean;
  onStart: (userCourse: UserCourse) => void;
  onStop: (userCourse: UserCourse) => void;
  onDelete: (userCourse: UserCourse) => void;
}

export const CourseActionButtons: FC<CourseActionButtonsProps> = ({
  userCourse,
  isAdmin,
  onStart,
  onStop,
  onDelete,
}) => {
  if (!isAdmin || userCourse.passed) return null;

  const onStartClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onStart(userCourse);
  };

  const onStopClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onStop(userCourse);
  };

  const onDeleteClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onDelete(userCourse);
  };

  return (
    <div className="flex items-center gap-1">
      {userCourse.started ? (
        <button
          type="button"
          onClick={onStopClick}
          title="Reset course"
          className={`${COURSE_ACTION_BUTTON_CLASS} hover:bg-(--warning-W200) hover:text-(--warning-W700)!`}
        >
          <RotateCcw className={COURSE_ACTION_ICON_CLASS} />
        </button>
      ) : (
        <button
          type="button"
          onClick={onStartClick}
          title="Start course"
          className={`${COURSE_ACTION_BUTTON_CLASS} hover:bg-(--success-S200) hover:text-(--success-S700)!`}
        >
          <Play className={COURSE_ACTION_ICON_CLASS} />
        </button>
      )}

      {!userCourse.started && (
        <button
          type="button"
          onClick={onDeleteClick}
          title="Remove course"
          className={`${COURSE_ACTION_BUTTON_CLASS} hover:bg-(--danger-D200) hover:text-(--danger-D700)!`}
        >
          <X className={COURSE_ACTION_ICON_CLASS} />
        </button>
      )}
    </div>
  );
};
